import { ClientUserMapped } from '@tassat/fred-extended-definitions';

export interface ClientUserSearchState {
    isOpen: boolean;
    isLoading: boolean;
    isComplete: boolean;
    isTrimmed: boolean;
    searchResults: ClientUserMapped[];
    resultTotal: number;
}

export const CLIENT_USER_SEARCH_INITIAL_STATE: ClientUserSearchState = {
    isOpen: false,
    isLoading: false,
    isComplete: false,
    isTrimmed: false,
    searchResults: [],
    resultTotal: 0
};

export type ClientUserSearchAction =
    | { type: 'OPEN_SEARCH' } |
    { type: 'CLEAR_SEARCH' } |
    { type: 'START_SEARCH' } |
    {
        type: 'RESULTS_RECEIVED';
        payload: {
            searchResults: ClientUserMapped[];
            resultTotal: number;
            isTrimmed: boolean;
        };
    };

export const ClientUserSearchReducer = (
    state: ClientUserSearchState,
    action: ClientUserSearchAction
): ClientUserSearchState => {
    switch (action.type) {
        case 'OPEN_SEARCH':
            return {
                ...CLIENT_USER_SEARCH_INITIAL_STATE,
                isOpen: true
            };
        case 'CLEAR_SEARCH':
            return CLIENT_USER_SEARCH_INITIAL_STATE;
        case 'START_SEARCH':
            return {
                ...state,
                isLoading: true,
                isComplete: false
            };
        case 'RESULTS_RECEIVED':
            return {
                ...state,
                isLoading: false,
                isComplete: true,
                isTrimmed: action.payload.isTrimmed,
                searchResults: action.payload.searchResults,
                resultTotal: action.payload.resultTotal
            };
        default:
            return state;
    }
};